import React from 'react';
import Lines from './Lines';


const Content = ({ items, className = 'main', tag = 'ol', tagStyle = '' }) => {
    const Tag = tag;

    return (
        <Tag className={ tagStyle }>
            {
                items.map(({ title, description, sections }, i) => {
                    return (
                        <li key={ `section-${ i }` } className={ `section ${ className }` }>
                            { title ? (<h3 className="title">{ title }</h3>) : null }
                            {
                                description ?
                                    (<article className="description">
                                        <Lines lines={ description } />
                                    </article>) :
                                    null
                            }
                            { sections ? <Content items={ sections } className="sub" tag={ tag } /> : null }
                        </li>
                    );
                })
            }
        </Tag>
    );
};

export default Content;
